
import {DEFAULT_STATE_VALUE} from '../constants';
import {metalQuality} from './utils';

// main logic file for price calculation


export  default function calcPrice (state) {
  var price=0
  if (state.m==='no')
      return 0
  const fromPrice = parseFloat(state['from'])
  if (state.hasOwnProperty('retail_price_set') === false)
    return 0

  const formula=state['price_formula']
  //console.log('price state',formula,state)
  for (let key in formula){
    let price_option =''
    let try_continue=false
    if (formula[key].hasOwnProperty('if-attr')){
 //     console.log('try_cont',try_continue,formula[key]['if-attr'],state[formula[key]['if-attr']],formula[key]['if-value'])
      if (formula[key]['if-value'].indexOf(state[formula[key]['if-attr']]) === -1)
        try_continue =true
    }
    if (try_continue) {
      price_option = DEFAULT_STATE_VALUE
      continue
    }
    for (let i in formula[key].value){
      if (price_option !== '')
        price_option+='-'
      let next_opt =  formula[key].value[i]
      let next_value;
    //  console.log('nestopt',next_opt,formula[key])
      
      switch (next_opt) {
        case 'attr':
          next_value =formula[key].attr
          break;
        case 'sku-control':
 //         if (state['list_sku'].length === 1)
 //           next_value =state['list_sku'][0]
 //         else
          let try_control = ''
          for (let obj in state['control'] ){
          //  console.log('iter',state['control'][obj])
            let curAttr = state['control'][obj]
            let curVal =state[curAttr]
           if (curVal  === undefined || curVal === DEFAULT_STATE_VALUE) {
              curVal =state['min_'+curAttr]
            }
            if (curAttr === 'm') {
              curVal= metalQuality(curVal)
            }
           
   //         console.log('curVal',curVal)
            if (try_control !== '') {
              try_control += '-'
            }
            try_control += curVal
          }
          next_value =state['list_sku'][try_control]
        //  console.log('next_value sku-control',next_value,try_control,'for next opt',next_opt,state)
          break;
        
               
        default:
          next_value = get_state(state,next_opt)
    //      console.log('next_value default',next_value,'next opt=',next_opt)
    
          //console.log('next_opt',next_opt)
          if (next_value === DEFAULT_STATE_VALUE) {
            if (state.hasOwnProperty('min_'+next_opt)){
              next_value = state['min_'+next_opt]
   //           console.log('min','min_'+next_opt,state['min_'+next_opt])
            }
            else
              if (['s1','s2','s3','s4','s5','s6','s7','s8','s9','s10'].indexOf(next_opt) !== -1)
                next_value = state['min_s1']
              else
                next_value = DEFAULT_STATE_VALUE
       }
          break;
      }
    
    //console.log('next_value$',next_value)
    if (next_value !== DEFAULT_STATE_VALUE)    
      price_option +=next_value  
    else
      price_option = DEFAULT_STATE_VALUE
      continue  
    }
    if (price_option !== DEFAULT_STATE_VALUE ) {
      if (formula[key].param === 'initial')
      {
        var cur_met='s'
        if (state['m'] !== 's' && state['m'] !== 'spy' && state['m'] !== 'spr' && state['m'] !== '-1' )
            cur_met='10'
        let next_initial_price =state['retail_price_set'][formula[key].param][cur_met]
/*         if (state['m'] == 'spy' || state['m'] == 'spr'){
          let plated = (100+ state.plated)/100
          next_initial_price = next_initial_price * plated 
        } */
          

        var len1 =state['e1'].length
        if (len1===0)
            len1=1
        //console.log('initial next_value$',state['e1'],len1,next_initial_price)

        price+=(len1)*next_initial_price
      }
      else
      {
      let next_price =state['retail_price_set'][formula[key].param][price_option]
      if (next_price === undefined)
        next_price= 0
      price+=next_price
      }
     //price = Number(price).toFixed(2)
     // console.log('price',price.toFixed(2),formula[key].param,price_option,state['retail_price_set'][formula[key].param][price_option])
      
    }
    
  }
    
  if (state.m ==='spy' || state.m ==='spr' ) {
    let plated = (100+ state.plated)/100
    price = price * plated 
  }
 // console.log('retail',fromPrice,state)
  if (price < fromPrice)
    return fromPrice.toFixed(2).toString()
  else  
    return price.toFixed(2).toString()
}
function get_state (state,val) {
  if (val !== 'm') {
    return state[val]
  }
  var metal = DEFAULT_STATE_VALUE
  switch (state[val]) {
    case 's':
    case 'spy':
    case 'spr':
          metal='s'
      break
    case 'g10y':
    case 'g10r':
    case 'g10w':
      metal='10'
      break
    case 'g14y':
    case 'g14r':
    case 'g14w':
      metal='14'
      break
    default:
      break

    }
  return metal
}


// WEBPACK FOOTER //
// ./src/reducers/calcPrice.js